import React, { useEffect, useState } from 'react';

export default function NewsSection({ uiLang, t, knownWords, onClose }) {
  const [items, setItems] = useState(null);
  const [updated, setUpdated] = useState(null);
  const [tip, setTip] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setItems(null);
    fetch('/api/ai/news?lang=' + encodeURIComponent(uiLang || 'ru'), { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (cancelled) return;
        if (d && Array.isArray(d.items)) { setItems(d.items); setUpdated(d.updated); }
        else { setItems([]); }
      })
      .catch(() => { if (!cancelled) setItems([]); });
    return () => { cancelled = true; };
  }, [uiLang]);

  const showTip = (ru, e) => {
    e.stopPropagation();
    const r = e.currentTarget.getBoundingClientRect();
    setTip({ text: ru, x: Math.round(r.left + r.width / 2), y: Math.round(r.top) });
  };

  return (
    <div className="news-overlay" onClick={() => { setTip(null); onClose(); }}>
      <div className="news-panel" onClick={(e) => { e.stopPropagation(); setTip(null); }}>
        <div className="news-head">
          <h2 className="news-title">{t('news')}</h2>
          <button type="button" className="news-close" aria-label="Закрыть" onClick={onClose}>×</button>
        </div>
        {items === null && <p className="news-info">{t('newsLoading')}</p>}
        {items !== null && items.length === 0 && <p className="news-info">{t('newsEmpty')}</p>}
        {items !== null && items.length > 0 && (
          <div className="news-list">
            {items.map((n, i) => (
              <article className="news-card" key={i}>
                <h3 className="news-card-title">{n.title}</h3>
                {n.title_translation && <p className="news-card-subtitle">{n.title_translation}</p>}
                <p className="news-card-text">{renderTagged(n.retelling, knownWords, showTip)}</p>
                <a className="news-card-link" href={n.link} target="_blank" rel="noopener noreferrer">{t('newsRead')}{n.source ? ' · ' + n.source : ''}</a>
              </article>
            ))}
          </div>
        )}
      </div>
      {tip && (
        <div className="news-tip" style={{ left: tip.x + 'px', top: tip.y + 'px' }}>{tip.text}</div>
      )}
    </div>
  );
}

function normNo(s) {
  return String(s || '').trim().toLowerCase().replace(/^(en|ei|et|å)\s+/i, '');
}

function renderTagged(text, knownWords, onTap) {
  if (!text) return null;
  const re = /\[([^|\]]+)\|([^\]]+)\]/g;
  const out = [];
  let last = 0, m, k = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const ru = m[1];
    const no = (m[2] || '').trim();
    if (no && no.toLowerCase() !== 'null' && knownWords && knownWords.has(normNo(no))) {
      out.push(React.createElement('span', { key: k++, className: 'news-no', title: ru, onClick: onTap ? (e) => onTap(ru, e) : undefined }, no));
    } else {
      out.push(ru);
    }
    last = re.lastIndex;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
